export const BaseMixin = {
	props: {
		color: {
			type: String,
			default: 'primary',
		},
	},
}
